import React from 'react';
import { Users, Sparkles, CalendarClock, PhoneCall, PhoneOff, ThumbsUp, ThumbsDown, UserX } from 'lucide-react';

const TONES = {
  purple: 'from-purple-500 to-purple-600',
  blue: 'from-blue-500 to-blue-600',
  emerald: 'from-emerald-500 to-emerald-600',
  amber: 'from-amber-500 to-amber-600',
  sky: 'from-sky-500 to-sky-600',
  slate: 'from-slate-500 to-slate-600',
  rose: 'from-rose-500 to-rose-600',
  orange: 'from-orange-500 to-orange-600',
};

const StatCard = ({ title, value, icon: Icon, tone, active, onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`text-left rounded-xl border bg-white p-4 transition-all duration-200 hover:shadow-lg ${
      active ? 'ring-2 ring-blue-500 border-blue-500' : 'border-slate-200'
    }`}
  >
    <div className="flex items-center gap-3">
      <div className={`p-2.5 rounded-xl bg-gradient-to-r ${TONES[tone] || TONES.slate}`}>
        <Icon className="h-4 w-4 text-white" />
      </div>
      <div className="min-w-0">
        <p className="text-2xl font-bold text-slate-900">{(value || 0).toLocaleString()}</p>
        <p className="text-xs font-medium text-slate-500 truncate">{title}</p>
      </div>
    </div>
  </button>
);

/**
 * Status cards for the Loans desk. Counts come from the server and honour every
 * active filter (date range, owner, search); clicking one filters the table.
 */
export const LoanStats = ({ counts = {}, activeStatus = 'all', onStatusChange, showUnassigned = false, onUnassignedClick, unassignedActive = false }) => {
  const cards = [
    { key: 'all', title: 'All Loans', value: counts.all, icon: Users, tone: 'purple' },
    { key: 'NEW', title: 'New', value: counts.NEW, icon: Sparkles, tone: 'blue' },
    { key: 'INTERESTED', title: 'Interested', value: counts.INTERESTED, icon: ThumbsUp, tone: 'emerald' },
    { key: 'FOLLOW_UP', title: 'Follow Up', value: counts.FOLLOW_UP, icon: CalendarClock, tone: 'amber' },
    { key: 'CALL_BACK', title: 'Call Back', value: counts.CALL_BACK, icon: PhoneCall, tone: 'sky' },
    { key: 'RNR', title: 'RNR', value: counts.RNR, icon: PhoneOff, tone: 'slate' },
    { key: 'NOT_INTERESTED', title: 'Not Interested', value: counts.NOT_INTERESTED, icon: ThumbsDown, tone: 'rose' },
  ];

  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 ${showUnassigned ? 'lg:grid-cols-8' : 'lg:grid-cols-7'} gap-4 mb-5`} data-testid="loan-stats">
      {cards.map((c) => (
        <StatCard
          key={c.key}
          title={c.title}
          value={c.value}
          icon={c.icon}
          tone={c.tone}
          active={!unassignedActive && activeStatus === c.key}
          onClick={() => onStatusChange(c.key)}
          testId={`loan-stat-${c.key.toLowerCase()}`}
        />
      ))}
      {showUnassigned && (
        <StatCard
          title="Unassigned"
          value={counts.unassigned}
          icon={UserX}
          tone="orange"
          active={unassignedActive}
          onClick={onUnassignedClick}
          testId="loan-stat-unassigned"
        />
      )}
    </div>
  );
};

export default LoanStats;
